<i18n>
{
  "fr": {
    "Export": "Exporter en Excel",
    "Title": "Rapport des disponibilités de ",
    "OtherOrVaries" : "Autre/Divers",
    "InternalFormation" : "Interne - Formation"
  }
}
</i18n>

<template>
  <section>
    <AppHeader :title="$t('Title') + ' ' + getMemberFormattedNameById($route.query.member)">
      <div class="row justify-content-end">
        <div class="col-auto">
          <ButtonExport
            :label="$t('Export')"
            @click="exportToExcel()"/>
        </div>
      </div>
    </AppHeader>
    <AppContainer>
      <BaseTabs slot="left">
        <BaseTab
          :to="{
            name: 'Availability-Global',
            query: $route.query
          }"
          label="Global"/>
        <BaseTab
          :to="{
            name: 'Availability-Details',
            params: { chargeToId: 1 },
            query: $route.query
          }"
          :label="$t('OtherOrVaries')" />
        <BaseTab
          :to="{
            name: 'Availability-Details',
            params: { chargeToId: 18 },
            query: $route.query
          }"
          :label="$t('InternalFormation')" />
      </BaseTabs>
      <router-view :key="$route.fullPath" />
    </AppContainer>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState('availability', ['timeEntries', 'member']),
    ...mapGetters('members', ['getMemberFormattedNameById']),
  },
  created() {
    if (!this.member || this.member !== this.$route.query.member) {
      this.$store.dispatch('availability/getTimeEntries', this.$route.query);
    }
  },
  methods: {
    exportToExcel() {
      this.$store.dispatch('availability/exportToExcel');
    },
  },
};
</script>
